import { Permissions } from '@models/permissions.enum';
import { Roles } from '@models/roles.enum';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import {
  NgbAccordionConfig,
  NgbAccordionModule,
} from '@ng-bootstrap/ng-bootstrap';
import { PermissionDirective } from '../directives/permission.directive';

@Component({
    selector: 'app-sidebar',
    imports: [NgbAccordionModule, PermissionDirective, RouterLink, RouterLinkActive],
    templateUrl: './sidebar.component.html',
    styleUrl: './sidebar.component.scss',
    standalone: true,
    providers: [NgbAccordionConfig]
})
export class SidebarComponent {

  Roles = Roles;
  Permissions = Permissions;
  constructor(config: NgbAccordionConfig) {
    // customize default values of accordions used by this component tree
    config.closeOthers = true;
  }

  isSidebarOpen: boolean = false;

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
}
